import { modSelector } from "@src/store/slices/experienceBuilder/common/utils/modSelector";
import { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";

export const getCopyKey = (mod: EmbeddedMod) => {
  // An anchored upsell has no selector; its anchor key is what identifies the
  // spot, and two anchored upsells with different keys are different spots.
  if ("anchorKey" in mod && mod.anchorKey) return `anchor:${mod.anchorKey}`;
  return modSelector(mod) ?? mod.type;
};
